import Mutations from '../../odata/mutations';

export default { ...new Mutations('vehicleInspection'), ...new Mutations('vehicleInspections') };
